import { values } from 'lodash-es';
import { useMemo } from 'react';
import { CustomerBalanceTransactionTypeEnum } from '../../../../types';
import { prettyName } from '../../../../utils';
import { IconName } from '../../../Icons';
import type { FilterableProperty } from '../types';

/**
 * This hook creates the filter property definition for CustomerBalanceTransactionTypeEnum properties.
 *
 * @returns Filter Property definition to use for CustomerBalanceTransactionTypeEnum filters
 */

export function useCustomerTransactionTypesFilter() {
  return useMemo(
    () =>
      ({
        key: 'TransactionTypes',
        label: 'Transfer Type',
        icon: IconName.ArrowUpDown,
        options: values(CustomerBalanceTransactionTypeEnum),
        getOptionLabel: value => prettyName(value),
      }) as const satisfies FilterableProperty,
    []
  );
}
